import React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Table, Card, Tag, Button, Typography, Spin, Badge, Tooltip } from 'antd';
import { DownloadOutlined, UserOutlined } from '@ant-design/icons';

class TabelaItensContratados extends React.Component {

  state = {
    tabelaItens: false,
    itensTabela: {
      header: [],
      body: [],
      total: []
    },
    pagination: {
      current: 1,
      pageSize: 10
    }
  };

  handleTableChange = (pagination) => {
    this.setState({ pagination });
  };

  async componentWillMount() {
    await this.criarHeaderTabelaItens();
    await this.criarBodyTabelaItens();
    await this.removerConviteDoNome();
    this.setState({ tabelaItens: true });
  }

  checarHeadersTabelaItens(nome, id, quantidade) {
    let header = this.state.itensTabela.header,
      itemPesquisado = header.find((i) => { return nome === i.produto });
    id = Number(id);
    if (itemPesquisado === undefined || itemPesquisado.produto !== nome) {
      header.push({ produto: nome, ids: [id], quantidade: quantidade });
    } else if (itemPesquisado.produto === nome) {
      header.forEach((item) => {
        if (item.produto === nome) {
          item.ids.push(id);
          item.quantidade += quantidade;
        }
      });
    }
    this.setState({ itensTabela: { ...this.state.itensTabela, header: header } });
  }

  criarBodyTabelaItens() {
    let { formandos } = this.props,
      { itens } = this.props.contrato,
      { header } = this.state.itensTabela,
      { pedidos } = this.props,
      total = [];

    header.forEach(() => total.push({ quantidade: 0, brinde: 0 }));
    formandos.forEach((formando) => {
      formando.itensTabela = [];
      header.forEach(() => formando.itensTabela.push({ quantidade: 0, brinde: 0 }));

      // Buscar pedidos deste formando
      let pedidosFormando = pedidos.find(p => p.id === formando.id);

      if (!pedidosFormando || !pedidosFormando.pedidos) {
        return;
      }

      // Filtrar apenas pedidos válidos (não cancelados)
      let pedidosValidos = pedidosFormando.pedidos.filter(pedido => {
        return pedido.status !== "Pedido cancelado";
      });
      // Processar itens dos pedidos válidos
      pedidosValidos.forEach((pedido) => {
        if (!pedido.itens) {
          return;
        }

        pedido.itens.forEach((itemPedido) => {
          let itemContrato = itens.find((i) => { return i.id === itemPedido.itemContrato });

          if (!itemContrato) {
            return;
          }

          let itensEmArray = itemContrato.itens.split(";");

          itensEmArray.forEach((item) => {
            if (item !== "") {
              let itemQuantidade = Number(item.split(" ")[0]),
                itemProduto = item.substring(item.split(" ")[0].length + 1);

              header.forEach((produto, j) => {
                if (produto.produto === itemProduto) {
                  let auxQtd = itemContrato.observacao === "kit" ? itemPedido.quantidade * itemQuantidade : itemPedido.quantidade;
                  if (itemContrato.observacao === "brinde") {
                    formando.itensTabela[j].brinde += auxQtd;
                    total[j].brinde += auxQtd;
                  } else {
                    formando.itensTabela[j].quantidade += auxQtd;
                    total[j].quantidade += auxQtd;
                  }
                }
              });
            }
          });
        });
      });
    });

    this.setState({ itensTabela: { ...this.state.itensTabela, body: formandos, total: total } });
  }

  async removerConviteDoNome() {
    let { header } = this.state.itensTabela,
      novoHeader = [];

    for (let i = 0; i < header.length; i++) {
      let item = header[i];
      novoHeader.push(item);
      if (item.produto.indexOf("Convite") !== -1) {
        novoHeader[i].produto = novoHeader[i].produto.replace("Convite ", "");
      }
      if (item.produto.indexOf("com") !== -1) {
        novoHeader[i].produto = novoHeader[i].produto.replace("com", "c/");
      }
      if (item.produto.indexOf("sem") !== -1) {
        novoHeader[i].produto = novoHeader[i].produto.replace("sem", "s/");
      }
      if (item.produto.indexOf("Aproveitamento") !== -1) {
        novoHeader[i].produto = novoHeader[i].produto.replace("Aproveitamento", "Aprov.");
      }
    }
    this.setState({ itensTabela: { ...this.state.itensTabela, header: novoHeader } });
  }

  async criarHeaderTabelaItens() {
    let { itens } = this.props.contrato;
    for (let i = 0; i < itens.length; i++) {
      let item = itens[i];
      if (item.observacao !== "brinde" && !item.produto.includes("Extra")) {
        if (item.observacao === "kit") {
          let auxItens = item.itens.split(";");
          for (let j = 0; j < auxItens.length; j++) {
            if (auxItens[j] !== "") {
              let nome = auxItens[j].substring(auxItens[j].split(" ")[0].length + 1)
              await this.checarHeadersTabelaItens(nome, item.id, item.quantidade * Number(auxItens[j].split(" ")[0]));
            }
          }
        } else {
          await this.checarHeadersTabelaItens(item.produto, item.id, item.quantidade);
        }
      }
    }
  }

  baixar(id) {
    let btn = document.querySelector(`#${id}`);

    if (btn) {
      btn.click();
    }
  }

  formandoPossuiPedidos(itens) {
    let quantidadeMaiorQueZero = false;

    itens.forEach((item) => {
      if (item.quantidade > 0) {
        quantidadeMaiorQueZero = true;
        return;
      }
    });

    return quantidadeMaiorQueZero;
  }


  _renderLabel(valor) {
    // Logic: if value > 0 then red (missing/negative logic in UI seems inverse? original: valor > 0 ? red : green)
    // Original code: if valor > 0 -> cor = red.
    // It seems 'valor' passed here is (contratada - total).
    // If contratada - total > 0, it means we have fewer than contracted -> Red?
    // Let's stick to original logic.
    let color = "success";
    let text = "+";

    if (valor > 0) {
      color = "error";
      text = "-";
    }

    return <Tag color={color}>{text}{Math.abs(valor)}</Tag>;
  }

  _renderLabelStatusPagamentoFormando(formando) {
    if (!formando || !formando.pedidos || formando.pedidos.length === 0) {
      return null;
    }

    // Calcular totais de pagamento
    let valorTotal = 0;
    let valorPago = 0;

    formando.pedidos.forEach(pedido => {
      if (pedido.status !== 'Pedido cancelado' && pedido.cobranca) {
        valorTotal += pedido.cobranca.valor || 0;
        valorPago += pedido.cobranca.valorJaPago || 0;
      }
    });

    if (valorTotal === 0) {
      return null;
    }

    // Determinar status
    if (valorPago >= valorTotal) {
      return <Tag color="#00a65a" style={{ borderRadius: 10 }}>PAGO</Tag>;
    } else if (valorPago > 0) {
      return <Tag color="#f39c12" style={{ borderRadius: 10 }}>PARCIAL</Tag>;
    } else {
      return <Tag color="#dd4b39" style={{ borderRadius: 10 }}>PENDENTE</Tag>;
    }
  }

  _renderResumoContratoMae() {
    const { Text } = Typography;
    const columns = [
      {
        title: '#',
        key: 'index',
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Produto',
        dataIndex: 'produto',
        key: 'produto',
      },
      {
        title: 'Qtd. contratada',
        dataIndex: 'quantidade',
        key: 'quantidade',
      },
      {
        title: 'Qtd. comprada',
        key: 'comprada',
        render: (_, record, index) => {
          const totalItem = this.state.itensTabela.total[index];
          if (!totalItem) return null;
          const diff = record.quantidade - totalItem.quantidade;
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: 100 }}>
              <Text>{totalItem.quantidade}</Text>
              {this._renderLabel(diff)}
            </div>
          );
        }
      }
    ];

    if (!this.state.tabelaItens) {
      return <div style={{ textAlign: 'center', padding: 20 }}><Spin tip="Carregando produtos do contrato..." /></div>;
    }

    return (
      <Card title="Produtos do contrato mãe" bordered={false} className="box-shadow-card">
        <Table
          className="custom-table-header"
          dataSource={this.state.itensTabela.header}
          columns={columns}
          rowKey="produto"
          pagination={false}
          footer={() => <span style={{ color: "#dd4b39", fontSize: 12 }}>Atenção: os produtos podem sofrer reajuste de preços caso a quantidade definida em contrato não seja atingida.</span>}
        />
      </Card>
    );
  }

  _renderTabelaQuantidade() {
    if (!this.state.tabelaItens) {
      return <div style={{ textAlign: 'center', padding: 20 }}><Spin tip="Carregando planilha..." /></div>;
    }

    const dynamicColumns = this.state.itensTabela.header.map((item, index) => ({
      title: item.produto,
      key: index,
      render: (_, record) => {
        const itemData = record.itensTabela[index];
        return (
          <span>
            {itemData.quantidade}
            {itemData.brinde > 0 && <span style={{ color: 'red', marginLeft: 5 }}> + {itemData.brinde} {itemData.brinde === 1 ? 'brinde' : 'brindes'}</span>}
          </span>
        );
      }
    }));

    const columns = [
      {
        title: '#',
        key: 'index',
        fixed: 'left',
        width: 50,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Formando',
        key: 'formando',
        fixed: 'left',
        width: 300,
        render: (_, record) => {
          const possuiPedidos = this.formandoPossuiPedidos(record.itensTabela);
          const statusTag = this._renderLabelStatusPagamentoFormando(this.props.pedidos.find(f => f.id === record.id));

          return (
            <Tooltip title={possuiPedidos ? "Clique para ver os pedidos" : record.nome}>
              <div
                onClick={this.props.handleClickFormando(this.props.pedidos.find(f => f.id === record.id))}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', flex: 1, paddingRight: 8 }}>
                  <span style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {record.nome}
                  </span>
                  {possuiPedidos && <UserOutlined style={{ marginLeft: 8, color: '#1890ff', flexShrink: 0 }} />}
                </div>
                <div style={{ flexShrink: 0 }}>
                  {statusTag}
                </div>
              </div>
            </Tooltip>
          )
        }
      },
      ...dynamicColumns
    ];

    return (
      <Card
        title="Planilha de quantidades"
        bordered={false}
        style={{ marginTop: 20 }}
        extra={
          <Button
            type="link"
            icon={<DownloadOutlined />}
            onClick={() => this.baixar("btnTabelaQuantidade")}
          >
            baixar
          </Button>
        }
      >
        <Table
          className="custom-table-header"
          dataSource={this.state.itensTabela.body}
          columns={columns}
          rowKey="id"
          scroll={{ x: true, y: 500 }}
          pagination={false}
        />

        {/* Hidden Table for Export Functionality */}
        <div style={{ display: 'none' }}>
          <ReactHTMLTableToExcel
            className="none"
            table="tabelaQuantidade"
            filename="Tabela de quantidades"
            sheet="tablexls"
            id="btnTabelaQuantidade"
            buttonText="download"
          />
          <table className="table" id="tabelaQuantidade">
            <thead>
              <tr>
                <th>#</th>
                <th>Formando</th>
                {this.state.itensTabela.header.map((item, i) => <th key={i}>{item.produto}</th>)}
              </tr>
            </thead>
            <tbody>
              {
                this.state.itensTabela.body.map((formando, i) => (
                  <tr key={formando.id}>
                    <td>{i + 1}</td>
                    <td>{formando.nome}</td>
                    {
                      formando.itensTabela.map((item, j) =>
                        <td key={j}>
                          {item.quantidade}
                          {item.brinde > 0 ? " + " + item.brinde + (item.brinde === 1 ? " brinde" : " brindes") : ""}
                        </td>
                      )
                    }
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </Card>
    );
  }

  render() {
    return (
      <div style={{ paddingBottom: 40 }}>
        <div className="row">
          <div className="col-sm-12 col-md-5">
            {this._renderResumoContratoMae()}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            {this._renderTabelaQuantidade()}
          </div>
        </div>
      </div>
    )
  }
}

export default TabelaItensContratados;